<template>
<el-drawer size="80%" :destroy-on-close="true" :visible.sync="visible" @close="$emit('input', false)" :before-close="handleClose" :wrapperClosable="false">
    <div slot="title" style="font-size: 1.2rem;font-weight: bold;">排课</div>
    <div style="padding: 1rem;">
        <el-form inline>
            <el-form-item prop="courseName">
                <el-input v-model="dataForm.courseName" placeholder="课程名称" clearable></el-input>
            </el-form-item>
            <el-form-item prop="itemId">
                <el-dict-select placeholder="所属系列" v-model="dataForm.itemId" type="courseItemSelects" :props="{value: 'id', label: 'itemName'}"></el-dict-select>
            </el-form-item>
            <el-form-item prop="stageId">
                <el-dict-select placeholder="所属阶段" v-model="dataForm.stageId" :params="stageDictParams" type="courseStageSelects" :props="{value: 'id', label: 'stageName'}"></el-dict-select>
            </el-form-item>
            <el-form-item prop="userStageLevel">
                <el-button @click="rgetDataList()">查询</el-button>
            </el-form-item>
        </el-form>
        <el-form inline>
            <el-form-item header-align="center" align="center" width="150px" label="任课老师">
                <el-select v-model="teacherGuild" placeholder="请选择任课老师" clearable filterable>
                    <el-option v-for="(item, index) in this.teacherOptions" :key="String(index)" :value="item.userId" :label="item.realName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item header-align="center" align="center" style="margin-left: 35px" min-width="260px" label="排课时间">
                <template>
                    <div style="display: flex;align-items: center;">
                        <!--  <el-date-picker
                            style="flex: 8;"
                            v-model="sDateGuide"
                            type="date"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                    </el-date-picker>
                    <span style="margin: 0 5px;"> : </span>-->
                        <el-time-select style="flex: 7;" placeholder="起始时间" v-model="sTimeGuide" :picker-options="{
                        start: '09:00',
                        step: '00:30',
                        end: '21:30'
                      }">
                        </el-time-select>
                        <span style="margin: 0 5px;"> - </span>
                        <el-time-select style="flex: 7;" placeholder="结束时间" v-model="eTimeGuide" :picker-options="{
                        start: '09:00',
                        step: '00:30',
                        end: '21:30',
                        minTime: sTimeGuide
                      }">
                        </el-time-select>
                    </div>
                </template>
            </el-form-item>
        </el-form>

        <el-row style="margin-bottom: 1rem;">
            <el-col>
                <el-button size="small" type="primary" :disabled="!selected.length" @click="duopai">批量排课</el-button>
            </el-col>
        </el-row>
        <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="handleSelectionChange" style="width: 100%;">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="courseName" header-align="center" align="center" label="课程名称">
            </el-table-column>
            <el-table-column prop="stageName" header-align="center" align="center" label="所属阶段">
            </el-table-column>
            <!-- <el-table-column
          prop="orgName"
          header-align="center"
          align="center"
          label="所属机构">
        </el-table-column> -->

            <!--  <el-table-column
                hidden
                header-align="center"
                align="center"
                width="250px"
                label="选择任课老师">
          <template slot-scope="{ row }" >
            <el-select
                    hidden
                    v-model=" row.userId"
                    placeholder="选择任课教师"
                    clearable
                    filterable
            >
              <el-option
                      v-for="(item, index) in teacherOptions"
                      :key="String(index)"
                      :value="item.userId"
                      :label="item.realName"
              ></el-option>
            </el-select>
          </template>

        </el-table-column>-->
            <el-table-column header-align="center" align="center" min-width="80px" label="选择排课日期">
                <template slot-scope="{ row }">
                    <div style="display: flex;align-items: center;">
                        <el-date-picker style="flex: 5;" v-model="row.sDate" align="right" type="date" :picker-options="pickerOptions" value-format="yyyy-MM-dd" placeholder="选择日期">
                        </el-date-picker>
                        <!--<el-time-select
                      hidden
                      style="flex: 7;"
                      placeholder="起始时间"
                      v-model="row.sTime"
                      :picker-options="{
                  start: '09:00',
                  step: '00:30',
                  end: '21:30'
                }">
              </el-time-select>
              <el-time-select
                      hidden
                      style="flex: 7;"
                      placeholder="结束时间"
                      v-model="row.eTime"
                      :picker-options="{
                  start: '09:00',
                  step: '00:30',
                  end: '21:30',
                  minTime: row.sTime
                }">
              </el-time-select>-->
                    </div>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" header-align="center" align="center">
                <template slot-scope="{ row }">
                    <el-button type="text" @click="danpai(row)">排课</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>
</el-drawer>
</template>

<script>
export default {
    props: {
        value: Boolean
    },
    watch: {
        value(val) {
            this.visible = val
        }
    },
    data() {
        return {
            visible: false,
            teacherGuild: undefined,
            teacherOptions: [],
            sDateGuide: undefined,
            sTimeGuide: undefined,
            eTimeGuide: undefined,
            studentIdsStr: undefined,
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '明天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周后',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
            dataForm: {
                courseId: undefined,
                courseName: undefined,
                itemId: undefined,
                stageId: undefined
            },
            submitForm: {},
            selected: []
        }
    },
    computed: {
        stageDictParams() {
            return {
                itemId: this.dataForm.itemId
            }
        },
        dictProps() {
            return {
                label: 'value',
                value: 'code'
            }
        },
        groupStageParams() {
            return {
                type: 'StudentStage'
            }
        },
        userStageLevelParams() {
            return {
                type: this.dataForm.userStage
            }
        },
    },
    created() {
        this.getDataList()
        this.teacherOptionsInit()
        this.doSearchPaiKe()
    },
    methods: {
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        /* guideTeacher() {
          for(let i = 0, length = this.dataList.length; i < length;i++) {
            this.dataList[i].userId = this.teacherGuild
          }
        },
       guideDate() {
          for(let i = 0, length = this.dataList.length; i < length;i++) {
            this.dataList[i].sDate = this.sDateGuide
          }
        },*/
        defaultChoseValue() {
            if (this.teacherOptions.size > 0 && this.dataList.size > 0) {
                this.dataList[0].userId = this.teacherOptions[0].userId;
            }
        },
        teacherOptionsInit() {
            this.$http({
                url: this.$http.adornUrl("common/teacherSelects"),
                method: "get",
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.teacherOptions = data.data;
                }
            });
        },
        danpai(row) {
            row.userId = this.teacherGuild
            row.sTime = this.sTimeGuide;
            row.eTime = this.eTimeGuide;
            if (!row.userId) {
                this.$message.warning('请选择任课老师！')
                return
            }
            if (!row.sTime || !row.eTime || !row.sDate) {
                this.$message.warning('请选择排课日期/时间！')
                return
            }
            row.startTime = row.sDate + ' ' + row.sTime + ':00'
            row.endTime = row.sDate + ' ' + row.eTime + ':00'
            this.$emit('submit', [row])
        },
        duopai() {
            let bol = true
            for (let i = 0, length = this.selected.length; i < length; i++) {
                this.selected[i].sTime = this.sTimeGuide;
                this.selected[i].eTime = this.eTimeGuide;
                let row = this.selected[i]
                /*if (!row.sDate){
                  this.selected[i].sDate = this.sDateGuide;
                }*/
                if (!row.userId) {
                    this.selected[i].userId = this.teacherGuild;
                }
                row = this.selected[i]
                if (!row.sTime || !row.eTime || !row.sDate) {
                    this.$message.warning('存在课程未选择排课日期/时间！')
                    bol = false
                    break
                }
                if (!row.userId) {
                    this.$message.warning('存在课程未选择任课老师！')
                    bol = false
                    break
                }
                row.startTime = row.sDate + ' ' + row.sTime + ':00'
                row.endTime = row.sDate + ' ' + row.eTime + ':00'
            }
            if (bol) {
                this.$emit('submit', this.selected)
            }
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 获取数据列表
        getDataList(studentUserIds, groupId) {
            this.dataListLoading = true
            if (studentUserIds) {
                this.studentIdsStr = studentUserIds.join("_")
                
                this.$http({
                    url: this.$http.adornUrl('course/course/list'),
                    method: 'get',
                    params: this.$http.adornParams({
                        'page': this.pageIndex,
                        'limit': this.pageSize,
                        'onlineStatus': 1,
                        'selectedStuId': this.studentIdsStr,
                        ...this.dataForm
                    })
                }).then(({
                    data
                }) => {
                    if (data && data.code === 0) {
                        this.dataList = data.page.list
                        this.totalPage = data.page.totalCount
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            } else if (this.studentIdsStr) {
                this.$http({
                    url: this.$http.adornUrl('course/course/list'),
                    method: 'get',
                    params: this.$http.adornParams({
                        'page': this.pageIndex,
                        'limit': this.pageSize,
                        'onlineStatus': 1,
                        'selectedStuId': this.studentIdsStr,
                        ...this.dataForm
                    })
                }).then(({
                    data
                }) => {
                    if (data && data.code === 0) {
                        this.dataList = data.page.list
                        this.totalPage = data.page.totalCount
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            }

            //TODO 填充班级信息
            this.getGroupData(groupId)
        },
        getGroupData(groupId) {
            if (groupId) {
                this.$http({
                    url: this.$http.adornUrl(`course/studentGroup/info/${groupId}`),
                    method: 'get'
                }).then(({
                    data
                }) => {
                    this.teacherGuild = data.studentGroup.userId
                    this.sTimeGuide = data.studentGroup.startTime
                    this.eTimeGuide = data.studentGroup.endTime
                })
            }
        },
        doSearchPaiKe() {
            let that = this;
            document.onkeypress = function (e) {
                let keycode = document.all ? event.keyCode : e.which;
                if (keycode == 13) {
                    that.rgetDataList();
                }
            }
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                });
            //清空缓存
            this.studentIdsStr = undefined
            this.dataForm = {}
            this.dataList = []
        },
    }
}
</script>

<style>

</style>
